import { createContext, useContext, useState, useEffect, useCallback } from "react";
import api from "@/lib/api";

const Ctx = createContext({ categories: [], byName: {}, refresh: () => {} });
export const useCategories = () => useContext(Ctx);

export function CategoriesProvider({ children }) {
  const [categories, setCategories] = useState([]);
  const refresh = useCallback(async () => {
    try {
      const res = await api.get("/categories");
      setCategories(res.data);
    } catch (e) { /* noop */ }
  }, []);
  useEffect(() => { refresh(); }, [refresh]);
  const byName = Object.fromEntries(categories.map((c) => [c.name, c]));
  return <Ctx.Provider value={{ categories, byName, refresh }}>{children}</Ctx.Provider>;
}

export function catChipStyle(hex) {
  if (!hex) return { backgroundColor: "#33415533", color: "#cbd5e1", borderColor: "#475569" };
  return { backgroundColor: `${hex}26`, color: hex, borderColor: `${hex}66` };
}

export function catChipSolid(hex, textColor) {
  const bg = hex || "#0891b2";
  const text = textColor === "black" ? "#0f172a" : "#ffffff";
  return { backgroundColor: bg, color: text, borderColor: bg };
}

export function catDotStyle(hex) {
  return { backgroundColor: hex || "#38bdf8" };
}
